export default __webpack_public_path__ + "static/media/Nunito-Italic.dc42e7f0.woff2";